var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card mt-4"},[_c('b-alert',{staticClass:"mb-0",attrs:{"show":"","variant":"warning"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Unauthorized!")]),_vm._v(" You are not allowed to go to that route ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }